// extracted by mini-css-extract-plugin
export var bookACall = "style-module--book-a-call--cc4a1";
export var bookACall__btn = "style-module--book-a-call__btn--0bd47";
export var bookACall__content = "style-module--book-a-call__content--46c73";
export var bookACall__text = "style-module--book-a-call__text--d0e98";